import React from 'react';
import { Phone, Navigation } from 'lucide-react';
import { bakeryInfo } from '../data/mock';

export const MobileBottomBar = () => {
  const handleRouteClick = () => {
    // Try to get user's location for directions
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          const destination = encodeURIComponent(bakeryInfo.address);
          // Open Google Maps with directions from current location
          window.open(
            `https://www.google.com/maps/dir/${latitude},${longitude}/${destination}`,
            '_blank'
          );
        },
        () => {
          // If location access denied, just open the destination
          const destination = encodeURIComponent(bakeryInfo.address);
          window.open(
            `https://www.google.com/maps/dir//${destination}`,
            '_blank'
          );
        }
      );
    } else {
      // Fallback for browsers without geolocation
      const destination = encodeURIComponent(bakeryInfo.address);
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${destination}`,
        '_blank'
      );
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-[#1e1919] border-t border-[#2a2525] p-2.5 sm:p-3 pb-[calc(0.625rem+env(safe-area-inset-bottom))] sm:pb-[calc(0.75rem+env(safe-area-inset-bottom))]">
      <div className="flex gap-2 sm:gap-3 max-w-lg mx-auto">
        {/* Call Button */}
        <a
          href={`tel:${bakeryInfo.phone}`}
          className="flex-1 flex items-center justify-center gap-1.5 sm:gap-2 bg-[#61525a] text-white py-3 sm:py-3.5 px-3 sm:px-4 rounded-lg sm:rounded-xl text-sm sm:text-base font-medium transition-all duration-300 active:scale-95 hover:bg-[#4a3f45]"
        >
          <Phone className="w-4 sm:w-5 h-4 sm:h-5" />
          <span>Anrufen</span>
        </a>

        {/* Route Button */}
        <button
          onClick={handleRouteClick}
          className="flex-1 flex items-center justify-center gap-1.5 sm:gap-2 bg-[#fad24b] text-[#1e1919] py-3 sm:py-3.5 px-3 sm:px-4 rounded-lg sm:rounded-xl text-sm sm:text-base font-medium transition-all duration-300 active:scale-95 hover:bg-[#e5c043]"
        >
          <Navigation className="w-4 sm:w-5 h-4 sm:h-5" />
          <span>Route</span>
        </button>
      </div>
    </div>
  );
};

export default MobileBottomBar;
